


import React, { useState, useEffect } from 'react';
import { Container, Typography, Grid, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const shuffleArray = (array) => {
  return array.sort(() => Math.random() - 0.5);
};

const MatchingPairs = ({ pairs }) => {
  const [englishWords, setEnglishWords] = useState([]);
  const [arabicWords, setArabicWords] = useState([]);
  const [selectedPair, setSelectedPair] = useState(null);
  const [matches, setMatches] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    setEnglishWords(shuffleArray(pairs.map(pair => pair.english)));
    setArabicWords(shuffleArray(pairs.map(pair => pair.arabic)));
  }, [pairs]);

  const handleWordClick = (word, language) => {
    if (!selectedPair) {
      setSelectedPair({ word, language });
    } else {
      if (language !== selectedPair.language) {
        const pairToCheck = language === 'english'
          ? { english: word, arabic: selectedPair.word }
          : { english: selectedPair.word, arabic: word };
        
        const isMatch = pairs.some(pair => 
          pair.english === pairToCheck.english && pair.arabic === pairToCheck.arabic
        );

        if (isMatch) {
          setMatches([...matches, pairToCheck]);
        }

        setSelectedPair(null);
      }
    }
  };

  const handleContinue = () => {
    navigate('/practice');
  };

  return (
    <Container maxWidth="sm" style={{ marginTop: '20px', textAlign: 'center' }}>
      <Typography variant="h5" gutterBottom>
        اضغط على الأزواج المتطابقة
      </Typography>
      <Grid container spacing={2} justifyContent="center">
        <Grid item xs={6}>
          {englishWords.map((word, index) => (
            <Button
              key={index}
              variant="outlined"
              fullWidth
              onClick={() => handleWordClick(word, 'english')}
              disabled={matches.some(match => match.english === word)}
              style={{ marginBottom: '10px' }}
            >
              {word}
            </Button>
          ))}
        </Grid>
        <Grid item xs={6}>
          {arabicWords.map((word, index) => (
            <Button
              key={index}
              variant="outlined"
              fullWidth
              onClick={() => handleWordClick(word, 'arabic')}
              disabled={matches.some(match => match.arabic === word)}
              style={{ marginBottom: '10px' }}
            >
              {word}
            </Button>
          ))}
        </Grid>
      </Grid>
      <Button
        variant="contained"
        color="primary"
        onClick={handleContinue}
        style={{ marginTop: '20px' }}
        disabled={matches.length !== pairs.length} // Disable until all pairs are matched
      >
        المتابعة
      </Button>
    </Container>
  );
};

export default MatchingPairs;
